// Brand-aligned palette for color-coding dogs in the unified calendar.
// Assignment is deterministic by the dog's position in the sorted dog list
// so colors stay stable across renders without storing anything per-dog.

export const DOG_PALETTE = [
  { name: "Navy",       solid: "#1C3A63", soft: "#1C3A6322", ring: "#1C3A63" },
  { name: "Brass",      solid: "#CC9C33", soft: "#CC9C3322", ring: "#CC9C33" },
  { name: "Terracotta", solid: "#A24F2E", soft: "#A24F2E22", ring: "#A24F2E" },
  { name: "Sage",       solid: "#5B7A55", soft: "#5B7A5522", ring: "#5B7A55" },
  { name: "Plum",       solid: "#7B4878", soft: "#7B487822", ring: "#7B4878" },
  { name: "Teal",       solid: "#2E6F73", soft: "#2E6F7322", ring: "#2E6F73" },
  { name: "Rust",       solid: "#A04A2A", soft: "#A04A2A22", ring: "#A04A2A" },
  { name: "Olive",      solid: "#6B6A2E", soft: "#6B6A2E22", ring: "#6B6A2E" },
];

// Stable color for a dog given the full sorted dogs list.
export function getDogColor(dogId, sortedDogIds) {
  const idx = sortedDogIds.indexOf(dogId);
  if (idx < 0) return DOG_PALETTE[0];
  return DOG_PALETTE[idx % DOG_PALETTE.length];
}

// Sort dogs deterministically by id for stable color assignment.
export function sortDogsForPalette(dogs) {
  return [...dogs].sort((a, b) => (a.id || "").localeCompare(b.id || ""));
}
